// src/pages/AgenciesList.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Typography, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getAgencies } from "../api/agencyApi";
import CreateAgencyForm from "./CreateAgencyForm";

const { Title } = Typography;

const AgenciesList = () => {
  const [agencies, setAgencies] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const { role } = useAuth();

  useEffect(() => {
    if (role !== "ADMIN") {
      message.error("Acceso no autorizado");
      navigate("/");
    }
  }, [role, navigate]);

  const fetchAgencies = async () => {
    try {
      const response = await getAgencies();
      setAgencies(response.data);
    } catch (error) {
      console.error("Error fetching agencies:", error);
      message.error("Error al obtener las agencias");
    }
  };

  useEffect(() => {
    fetchAgencies();
  }, []);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleSuccess = () => {
    closeModal();
    fetchAgencies();
  };

  const columns = [
    { title: "Código", dataIndex: "codigo", key: "codigo" },
    { title: "Agencia", dataIndex: "name", key: "name" },
    { title: "Empresa", dataIndex: "company", key: "company" },
    {
      title: "Marca Dealer",
      dataIndex: "brandDealer",
      key: "brandDealer",
      render: (brandDealer) => (brandDealer ? brandDealer.name : ""),
    },
    { title: "Provincia", dataIndex: "province", key: "province" },
    { title: "Ciudad", dataIndex: "city", key: "city" },
    { title: "Dirección", dataIndex: "address", key: "address" },
    { title: "Latitud", dataIndex: "latitude", key: "latitude" },
    { title: "Longitud", dataIndex: "longitude", key: "longitude" },
  ];

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0,0,0,0.5)",
        minHeight: "calc(100vh - 80px)",
      }}
    >
      <Title level={2} style={{ color: "#fff" }}>
        Listado de Agencias
      </Title>
      <Button type="primary" onClick={openModal} style={{ marginBottom: 16 }}>
        Crear Agencia
      </Button>

      <Table
        columns={columns}
        dataSource={agencies}
        rowKey="id"
        style={{
          background: "#2a2a2a",
          color: "#ccc",
        }}
      />

      <Modal
        title={<span style={{ color: "#fff" }}>Crear Agencia</span>}
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
        bodyStyle={{ background: "#1f1f1f", color: "#ccc" }}
      >
        <CreateAgencyForm onSuccess={handleSuccess} onCancel={closeModal} />
      </Modal>
    </div>
  );
};

export default AgenciesList;
